"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionSection = void 0;
var _i18n = require("@ori/i18n");
var _presentationComponents = require("@ori/presentation-components");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _internal = require("../../hooks/internal");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionSection = () => {
  const {
    currentShade: {
      subscriptionBenefitBanner
    }
  } = (0, _internal.useProduct)();
  const {
    message,
    readMoreText,
    readMoreUrl,
    registerText,
    registerUrl,
    signInText,
    title
  } = subscriptionBenefitBanner ?? {};
  const translatedMessage = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.DynamicFormattedMessage, {
    translatedMessage: message ?? '',
    values: {
      SignInLink: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.TextLink, {
        testId: _constants.LOGIN_LINK,
        onClick: _presentationUtils.doLogin,
        children: signInText
      }),
      RegisterLink: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.TextLink, {
        href: registerUrl,
        testId: _constants.REGISTER_LINK,
        children: registerText
      })
    }
  }), [message, registerText, registerUrl, signInText]);
  if (!subscriptionBenefitBanner) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.AnonymousSubscriptionBanner, {
    title: title,
    message: translatedMessage,
    readMoreText: readMoreText,
    readMoreLink: readMoreUrl
  });
};
exports.SubscriptionSection = SubscriptionSection;
